import { FunctionalComponent } from 'preact';

export interface IIconComponentProps {
  class?: string;
  width?: string;
  height?: string;
  icon: string;
  onClick?: () => void;
}

const Icon: FunctionalComponent<IIconComponentProps> = (props) => {
  const { icon, width, height } = props as Required<typeof props>;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" {...props}>
      <use href={`#${icon}`} />
    </svg>
  );
};

Icon.defaultProps = {
  width: '12px',
  height: '12px',
  onClick: () => {},
};

export { Icon };
